import { AppEnvEnum } from '@ulysses-inc/harami_api_client'
import packageJson from '~/../package.json'

const haramiMockApiEndpoints: readonly string[] = (
  import.meta.env.VITE_HARAMI_MOCK_API_ENDPOINTS ?? ''
)
  .split(',')
  .map(endpoint => endpoint.trim())

export const getBasePath = () => {
  return import.meta.env.VITE_HARAMI_API_ENDPOINT
}

export const getHaramiWebBaseUrl = () => {
  return import.meta.env.VITE_HARAMI_WEB_BASE_URL
}

// キオスク端末アカウント (Device) 認証用エンドポイント
export const getDeviceAuthTokenEndpoint = () => {
  return `${import.meta.env.VITE_RUMP_MTLS_ORIGIN}/auth/v1/token`
}

export const getCreateAuthSessionsEndpoint = () => {
  return `${import.meta.env.VITE_HARAMI_API_ENDPOINT}/auth/sessions`
}

export const getDeviceAuthOidcClientId = () => {
  return import.meta.env.VITE_RUMP_MTLS_OIDC_CLIENT_ID
}

// アクセストークンに要求する audience の一覧（カンマ区切りで設定する）。
// 付与されるのは Rump にクライアント登録された audience の範囲内のみ。
// 未設定・空値はビルド時に検出される（vite.config.ts）
export const getDeviceAuthAudiences = (): readonly string[] => {
  return import.meta.env.VITE_RUMP_MTLS_AUDIENCE.split(',')
    .map(audience => audience.trim())
    .filter(audience => audience !== '')
}

export const isProductionMode = () => {
  return import.meta.env.MODE === 'prod'
}

export const appEnv = {
  isLocal: import.meta.env.VITE_APP_ENV === AppEnvEnum.LOCAL,
  isDevelopment: import.meta.env.VITE_APP_ENV === AppEnvEnum.DEV,
  isProduction: import.meta.env.VITE_APP_ENV === AppEnvEnum.PRODUCTION,
}

// アプリの動作モード
// - kiosk: キオスク端末。Device 認証によるログインのみを提供する
// - app:   通常のユーザーログインのみを提供する（VITE_APP_MODE 未設定時のデフォルト）
export const appMode = {
  isKiosk: import.meta.env.VITE_APP_MODE === 'kiosk',
  isApp: import.meta.env.VITE_APP_MODE !== 'kiosk',
}

export const getAppVersion = () => {
  return packageJson.version
}

export const getGitCommitHash = () => {
  return import.meta.env.VITE_GIT_COMMIT_HASH
}

export const getHaramiMockApiEndpoints = () => {
  return haramiMockApiEndpoints
}
